import { useQuery } from 'react-query';
import { getSpeakerById } from 'src/common/services/speakers';
import { QueryKey } from 'src/config/queryKey';
import { Speaker } from 'src/common/models/speaker';

export const useSpeakerQuery = (speakerId?: number, initialData?: () => Speaker | undefined) =>
  useQuery(
    [QueryKey.Speaker, speakerId],
    () => (speakerId ? getSpeakerById(speakerId) : undefined),
    {
      enabled: !!speakerId,
      initialData,
    },
  );
